import React, { useState } from 'react';
import '../styles/Slider.css';

const SliderTest = ({ images = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(null);
  const [touchEndX, setTouchEndX] = useState(null);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    setTouchEndX(e.changedTouches[0].clientX);

    if (touchStartX - touchEndX > 50) {
      nextSlide(); // sola kaydırma
    } else if (touchStartX - touchEndX < -50) {
      prevSlide(); // sağa kaydırma
    }

    // sıfırla
    setTouchStartX(null);
    setTouchEndX(null);
  };

  return (
    <div className="slider"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}>
      <div
        className="slides"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {images.map((src, index) => (
          <div className="slide" key={index}>
            <img src={src} alt={`Slide ${index + 1}`} />
          </div>
        ))}
      </div>

      <div className="slider-buttons">
        <button onClick={prevSlide}>&#10094;</button> {/* Sol ok */}
        <button onClick={nextSlide}>&#10095;</button> {/* Sağ ok */}
      </div>

      <div className="slider-dots">
        {images.map((_, index) => (
          <span
            key={index}
            className={index === currentIndex ? 'dot active' : 'dot'}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

const Slider = () => {
  const imageList = [
    './images/Slider1.png',
    './images/Slider2.png',
    './images/Slider3.png',
    './images/Slider4.png',
    './images/Slider5.png'
  ];

  return (
    <div>
      <SliderTest images={imageList} />
    </div>
  );
};

export default Slider;